export default "__VITE_ASSET__adxD9o07__"